module.exports = __webpack_public_path__ + "1467967779ac4d994833f7e686bbdaaf.svg";